import React from 'react';

export default function JobDrawer({ node, onClose }) {
  const isOpen = !!node; // Convertit le node en booléen

  const drawerStyle = {
    position: 'fixed',
    top: 0,
    right: 0,
    height: '100vh',
    width: '450px',
    maxWidth: '90%',
    backgroundColor: '#fff',
    boxShadow: '-10px 0 30px rgba(0,0,0,0.1)',
    transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
    transition: 'transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
    zIndex: 1000,
    padding: '30px',
    boxSizing: 'border-box',
    overflowY: 'auto'
  };

  const backdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.4)',
    backdropFilter: 'blur(2px)', // Petit flou sympa
    zIndex: 999,
    opacity: isOpen ? 1 : 0,
    pointerEvents: isOpen ? 'all' : 'none',
    transition: 'opacity 0.3s ease'
  };

  if (!node) return <div style={drawerStyle} />;

  // Données mockées (Simuler ce que l'API renverrait)
  const color = node.data.familyColor || '#333';

  return (
    <>
      <div style={backdropStyle} onClick={onClose} />

      <div style={drawerStyle}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute', top: 20, right: 20,
            background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#999'
          }}
        >✕</button>

        <h5 style={{ color: color, textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 5 }}>
          Fiche Métier
        </h5>
        <h1 style={{ margin: '0 0 20px 0', fontSize: '32px' }}>{node.data.label}</h1>

        <div style={{ display: 'flex', gap: '10px', marginBottom: '30px' }}>
          <span style={{ background: '#f0f2f5', padding: '5px 10px', borderRadius: '4px', fontSize: '14px' }}>📍 Paris / Remote</span>
          <span style={{ background: '#e6fffa', color: '#2c7a7b', padding: '5px 10px', borderRadius: '4px', fontSize: '14px' }}>💰 45k€ - 60k€</span>
        </div>

        <p style={{ lineHeight: '1.6', color: '#555', fontSize: '16px' }}>
          En tant que <strong>{node.data.label}</strong>, vous serez au cœur de l'équipe.
          Ce rôle est une étape cruciale qui permet d'accéder aux postes de Lead ou d'expertise technique.
        </p>

        <h3 style={{ marginTop: '30px' }}>Compétences Clés</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {['Leadership', 'Agile', 'English', 'Mentoring', 'Problem Solving'].map(s => (
            <span key={s} style={{ border: '1px solid #ddd', padding: '6px 12px', borderRadius: '20px', fontSize: '13px' }}>
              {s}
            </span>
          ))}
        </div>

        <h3 style={{ marginTop: '30px' }}>Passerelles Possibles</h3>
        <ul style={{ paddingLeft: '20px', color: '#555', lineHeight: '1.8' }}>
          <li>Vers le Management (Team Lead)</li>
          <li>Vers l'Expertise (Staff Engineer)</li>
          <li>Vers le Produit (Product Manager)</li>
        </ul>

        <button style={{
          marginTop: '40px', width: '100%', padding: '15px',
          backgroundColor: color, color: 'white',
          border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer'
        }}>
          Voir les parcours détaillés
        </button>
      </div>
    </>
  );
}